import { useQueries } from '@tanstack/react-query';
import { useApi } from '../../api/api-context';
import { getBudgetQueryOptions } from './use-get-budget';
import { getRecurringTransactionsQueryOptions } from '../../recurring-transaction/api/use-get-recurring-transactions';
import { getViewsQueryOptions } from '../../view/api/use-get-views';
import { getAccountsQueryOptions } from '../../account/api/use-get-accounts';
import { getCategoriesQueryOptions } from '../../category/api/use-get-categories';
import { getBucketsQueryOptions } from '../../bucket/api/use-get-buckets';
import { getTransactionsQueryOptions } from '../../transaction/api/use-get-transactions';
/**
 * Hook to fetch all budget-related data in a single call.
 *
 * @param {string} budgetId - The ID of the budget.
 * @returns Budget data, loading state, and errors.
 */
export const useGetBudgetGraphApi = (budgetId) => {
    const api = useApi();
    const results = useQueries({
        queries: [
            getBudgetQueryOptions(budgetId, api),
            getAccountsQueryOptions(budgetId, api),
            getCategoriesQueryOptions(budgetId, api),
            getBucketsQueryOptions(budgetId, api),
            getTransactionsQueryOptions(budgetId, api),
            getRecurringTransactionsQueryOptions(budgetId, api),
            getViewsQueryOptions(budgetId, api),
        ],
    });
    // booleans
    const isLoading = results.some((r) => r.isLoading);
    const isFetching = results.some((r) => r.isFetching);
    const error = results.find((r) => r.error)?.error;
    // combined refetch
    const refetchAll = () => Promise.all(results.map((r) => r.refetch()));
    // destructure data out
    const [budgetResult, accountsResult, categoriesResult, bucketsResult, transactionsResult, recurringTransactionsResult, viewsResult,] = results;
    return {
        isLoading,
        isFetching,
        error,
        refetch: refetchAll,
        budget: budgetResult.data,
        accounts: accountsResult.data,
        categories: categoriesResult.data,
        buckets: bucketsResult.data,
        transactions: transactionsResult.data,
        recurringTransactions: recurringTransactionsResult.data,
        views: viewsResult.data,
    };
};
